import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error("Missing Supabase environment variables. Pastikan REACT_APP_SUPABASE_URL dan REACT_APP_SUPABASE_ANON_KEY sudah terisi.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);